import styled from "@emotion/styled";
import React from "react";
import {
  checkIfTimeSheetStrategy,
  getClockInStrategy,
  getClockOutStrategy,
} from "../clockInOutUtils";
import { VisitInstanceDetails } from "../messages";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { AppButton } from "./Generic/AppButton";
import Flex from "./Generic/Flex";

interface Props {
  visitDetails: VisitInstanceDetails;
  canSubmitTimeSheet: boolean;
  onSubmitTimeSheet: () => void;
  onClickOpenBottomSheet: (visitInstance: VisitInstanceDetails) => void;
}

const StartNowBottomSheetFooter = (props: Props) => {
  const clockInStrategy = getClockInStrategy(props.visitDetails);
  const clockOutStrategy = getClockOutStrategy(props.visitDetails);
  const isTimesheetStrategy = checkIfTimeSheetStrategy(clockInStrategy, clockOutStrategy);

  const handleClickOpenBottomSheet = () => {
    props.onClickOpenBottomSheet(props.visitDetails);
  };

  const submitTimesheetButton = (
    <AppButton variant="filled" size="small" onClick={props.onSubmitTimeSheet}>
      <span>{translate(STRINGS.SUBMIT_DUTIES)}</span>
    </AppButton>
  );

  const openButtomSheetButton = (
    <AppButton variant="filled" size="small" onClick={handleClickOpenBottomSheet}>
      <span>{translate(STRINGS.CLOCK_IN_OUT_SUBMIT_DUTIES)}</span>
    </AppButton>
  );

  const isTimeSheetSubmitted =
    props.visitDetails.timeSheetSubmittedAt !== null &&
    props.visitDetails.timeSheetApprovedAt === null;

  return (
    <StartNowBottomSheetFooter.Root>
      <Flex stretchItems={true}>
        {isTimesheetStrategy || isTimeSheetSubmitted
          ? submitTimesheetButton
          : openButtomSheetButton}
      </Flex>
    </StartNowBottomSheetFooter.Root>
  );
};

StartNowBottomSheetFooter.Root = styled.div`
  box-shadow: none;
  padding: 16px;
`;

export default StartNowBottomSheetFooter;
